var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplaintsAndSuggestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13708_26860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85573 11.667V11.1495C9.85533 10.8084 9.94477 10.4733 10.1151 10.1778C10.2853 9.88227 10.5304 9.63683 10.8257 9.46616C11.7641 8.91616 12.0874 7.75199 11.5374 6.81366C10.9874 5.87532 9.82323 5.55199 8.88489 6.10199C8.30156 6.45866 7.91406 7.07282 7.91406 7.78449M9.99739 14.167H9.99073M18.3307 10.0003C18.3307 5.39783 14.5999 1.66699 9.99739 1.66699C5.3949 1.66699 1.66406 5.39783 1.66406 10.0003C1.66406 14.6028 5.3949 18.3337 9.99739 18.3337C14.5999 18.3337 18.3307 14.6028 18.3307 10.0003Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13708_26860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintsAndSuggestions);
export default __webpack_public_path__ + "static/media/complaints_and_suggestions.dc722ca5e7c3e861a33d8363e655f5ee.svg";
export { ForwardRef as ReactComponent };